import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatSelect } from '@angular/material/select';

@Component({
  selector: 'app-grouping-column-list',
  templateUrl: './grouping-column-list.component.html',
  styleUrls: ['./grouping-column-list.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => GroupingColumnListComponent),
      multi: true
    }
  ]
})
export class GroupingColumnListComponent implements ControlValueAccessor {
  @Input()
  title: string | null = null;
  @Input()
  availableColumns: GroupingColumn[] = [];

  selected: string[] = [];
  disabled: boolean = false;

  onChange: any = () => { };
  onTouched: any = () => { };

  constructor() { }

  getColumnName(column: string): string {
    return this.availableColumns.find(c => c.name === column)?.toTranslate ?? '-?-';
  }

  handleSelectedGroupingColumn(column: string, select: MatSelect): void {
    this.selected.push(column);
    setTimeout(() => select.writeValue(null));
    this.onChange(this.selected);
  }

  handleRemoveGroupingColumn(column: string): void {
    this.selected = this.selected.filter(c => c !== column);
    this.onChange(this.selected);
  }

  isColumnAvailableToSelect(name: string): boolean {
    return !this.selected.includes(name);
  }

  canDisplayAddCircle(): boolean {
    return this.selected.length < this.availableColumns.length;
  }

  writeValue(value: string[] | null): void {
    this.selected = value ?? [];
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

}

export class GroupingColumn {
  constructor(public readonly name: string, public readonly toTranslate: string) { }
}

